import Section from 'components/common/Section'
import { SectionHeader } from 'components/marketing/SectionHeader'
import TestimonialCard from 'components/TestimonialCard'
import { ComponentTestimonialCentered } from 'types/generated/contentful'
import { useThemeColor } from './ThemeContext'

export const TestimonialCentered = ({
  headline,
  quote,
}: ComponentTestimonialCentered): JSX.Element => {
  const themeColor = useThemeColor()

  return (
    <Section bgColor='white'>
      <SectionHeader title={headline!} highlight={themeColor} />

      <div className='max-w-screen-md mx-auto'>
        <TestimonialCard
          quote={quote!.text!}
          name={quote!.author!.name!}
          title={`${quote!.author!.role!} ${quote!.author!.company!.name!}`}
          twitter={quote!.author!.twitterHandle!}
          profileImage={quote!.author!.avatar!.url!}
        />
      </div>
    </Section>
  )
}
